import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/system";
import styles from "./drawerComponent.module.scss";
import i18next from "i18next";
import PropTypes from "prop-types";

const StyledDrawer = styled(Drawer)((props) => ({
  "&.MuiDrawer-root": {
    position: "fixed",
    marginLeft: "auto",
    top: props.top,

    "& .MuiBackdrop-root": {
      top: props.top,
    },
    "& .MuiDrawer-paper": {
      position: "absolute",
      overflow: "hidden",
      padding: "32px 0",
    },
  },
}));
const StyledContentBox = styled(Box)((props) => ({
  height: "100%",
  display: "flex",
}));
export default function DrawerComponent(props) {
  const { position, drawerState, toggleDrawer, contentSection, title } = props;
  const [height, setHeight] = useState(window.innerHeight);
  const [top, setTop] = useState(
    document.body.scrollHeight <= document.body.clientHeight ? 136 : 72
  );

  useEffect(() => {
    function handleResize() {
      setHeight(
        document.body.scrollHeight <= document.body.clientHeight
          ? window.innerHeight - 136
          : window.innerHeight - 72
      );
      setTop(
        document.body.scrollHeight <= document.body.clientHeight ? 136 : 72
      );
    }

    window.addEventListener("scroll", handleResize);

    return (_) => {
      window.removeEventListener("scroll", handleResize);
    };
  });

  const content = (position, contentSection) => (
    <Box className={styles.drawerComponentWrapper}>
      <Box className={styles.drawerHeader}>
        <Box className={styles.boxWithUnderlline}>
          <Box className={styles.title}>{i18next.t(title)} </Box>{" "}
          <Box>
            <Box
              className={styles.closeIcon}
              onClick={toggleDrawer(position, false)}
              onKeyDown={() => {}}
            ></Box>
          </Box>
        </Box>
      </Box>
      <StyledContentBox>
        <Box className={styles.drawerMainContent}>{contentSection}</Box>
      </StyledContentBox>
    </Box>
  );

  return (
    <div data-testid="DrawerComponent">
      <StyledDrawer
        anchor={position}
        open={drawerState}
        onClose={toggleDrawer(false)}
        top={top}
        height={height}
      >
        {content(position, contentSection)}
      </StyledDrawer>
    </div>
  );
}

DrawerComponent.propTypes = {
  position: PropTypes.any,
  drawerState: PropTypes.any,
  toggleDrawer: PropTypes.any,
  contentSection: PropTypes.any,
  title: PropTypes.any,
};
